<template>
  <div class="responsibilityPage" id="tinyScreenResponsibility">
    <Header></Header>
    <!-- banner -->
    <div class="bannerHeaderBox">
      <div class="container">
        <div class="storyTxt">
          <div v-if="lang == 'en'">
            <h5>{{bannerBox.enSubContent}}</h5>
            <span>{{bannerBox.enContent}}</span>
          </div>
          <div v-else>
            <h5>{{bannerBox.cnSubContent}}</h5>
            <span>{{bannerBox.cnContent}}</span>
          </div>
        </div>
        <img class="fr mt30 phonePic" width="300px" :src="bannerBox.pcAdvertUrl">
      </div>
    </div>
    <div class="section1 middle descption">
      <div class="container">
         <div class="txtBox">
          <p v-html="responsibilityTxt"></p>
        </div>
      </div>
    </div>
    <!-- section1 -->
    <div class="section1 middle">
      <ul class="container">
        <li v-for="(item,index) in list" :key="index">
          <div class="bannerBox">
            <div class="bannerPic" :style="{backgroundImage:item.thumbnail?'url('+item.thumbnail+')':'url('+require('../../assets/picture/blank.png')+')'}">
<!--               <img  :src="item.thumbnail?item.thumbnail:require('../../assets/picture/blank.png')"> -->
            </div>
          </div>
          <div class="liBox">
            <h5>{{item.title}}</h5>
            <p v-html="item.content"></p>
           <!--  <div class="date" @click="goDetail(item.id)">
              <span>查看详情</span>
              <img width="11px" src="../../assets/picture/occupation/more.png">
            </div> -->
          </div>
        </li>
      </ul>
       <div class="pagination">
         <el-pagination class="pagination" @current-change="handleChangePage" :total="dataTotal"
          @size-change="handleSizeChange" :current-page.sync="fromData.pageNum"
            layout="prev, pager, next" :page-size="fromData.pageSize">
          </el-pagination>
      </div>   
    </div>
    <!-- footer -->
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '../common/header';
import Footer from '../common/footer';
import {formatDate} from '../../plugins/formatDate.js'
export default {
  data() {
    return {
      isShowSearch:false,
       fromData:{
          pageNum:1,
          pageSize:10,
          typeId:'11',
          limitWord:0,
      },
      dataTotal:0,
      list:[],
      lang:'',
      responsibilityTxt:'',
      bannerBox:{
        pcAdvertUrl:'',
        mobileAdvertUrl:'',
        cnContent:'',
        cnSubContent:'',
        enContent: '',
        enSubContent: '',
      }  
    };
  },
  components: { Header,Footer },
  created(){
    this.lang = window.sessionStorage.getItem("language")?window.sessionStorage.getItem("language"):'cn';
  },
  mounted(){
    this.loadData();
    this.getShehuizeren();
    this.getAdvert();
  },
  filters: {
      formatDate(time) {
        time = time * 1000
        let date = new Date(time)
        return formatDate(date, 'yyyy-MM-dd hh:mm')
      }
  },
  methods: {
    showSearch(){
      this.isShowSearch = !this.isShowSearch;
    },
     //分页获取文章信息
     async loadData() {
         const { data: res } = await this.$http.get("/article/getArticleByPage.do?pageNum="+this.fromData.pageNum+"&pageSize="+this.fromData.pageSize+"&typeId="+this.fromData.typeId+"&limitWord="+this.fromData.limitWord);
        // 提示message
        if (res.code !== 200) return this.$message.error(res.message);
       this.list = res.data.list;
       this.total = res.data.total;
    },
    // 获取社会责任文案
     async getShehuizeren() {
         const { data: res } = await this.$http.get("/article/getShehuizeren.do")        // 提示message
        if (res.code !== 200) return this.$message.error(res.message);
       this.responsibilityTxt = res.data.content;
    },
    handleChangePage(pageNum) {
      this.fromData.pageNum = pageNum;
      this.loadData();
    },
    // 切换单页数量事件
    handleSizeChange(pageSize) {
      this.fromData.pageSize = pageSize;
      this.loadData();
    },
    goDetail(id){
      this.$router.push({  
       path: '/searchDetail',  
       query: {   
         id: id,   
       }   
    })
    },
     // 根据埋点ID及非必填项获取广告位
    async getAdvert() {
        const { data: res } = await this.$http.get("/advert/getAdvert.do?pointId=8");
        // 提示message
        if (res.code !== 200) return this.$message.error(res.message);
        this.bannerBox = {
          ...res.data[0]
        };
    },
  }
};
</script>

<style lang="less" scoped>
.responsibilityPage{
  .bannerHeaderBox{    
    width: 100%;
    height: 360px;
    background: #333333;
    display: flex;
    .storyTxt{
        display: inline-block;
        padding-top: 112px;
       h5{      
        font-size: 14px;
        /*font-family: PingFangSC-Medium, PingFang SC;*/
        font-weight: 100;
        color: #fff;
        line-height: 22px;
        margin-bottom: 36px;
      }
      span{
        font-size: 40px;
         font-weight: 100;
         color: #fff;
      }
       img{      
        margin-top: 50px;
      }
    }
  }
  /*********************************************/
  .section1{
    .txtBox{
      max-width: 1008px;
      font-size: 24px;
      font-family: PingFangSC-Thin, PingFang SC;
      font-weight: 100;
      color: #333333;
      line-height: 44px;
      letter-spacing: 1px;
      text-align: left;
      margin:70px 0 0 0;
      /deep/ strong{
        font-weight: 100;
        font-size: 24px;
        font-family: PingFangSC-Thin, PingFang SC;
        font-weight: 100;
        color: #333333;
        line-height: 44px;
        letter-spacing: 1px;
      }
      /deep/ span{
        background: none!important;
      }
    }
    ul{
      li{
        padding:70px 0;
        display: flex;
        border-bottom: 1px solid #D5D5D5;
        .bannerBox{          
          .bannerPic{
         width: 384px;
          height: 276px;
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center center;
          overflow:hidden;  
          margin-right: 100px;
            img{
            height: 100%;
            }
          }
        }
        .liBox{
          h6{
            margin-bottom: 2px;
            font-size: 14px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #353535;
            line-height: 20px;
            letter-spacing: 1px;
          }
          h5{
            margin-top: -5px;           
            font-size: 26px;
            font-family: PingFangSC-Light, PingFang SC;
            font-weight: 300;
            color: #900211;
            line-height: 37px;
            margin-bottom: 34px;
          }
          p{            
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #9A9A9A;
            line-height: 30px;
            width: 398px;
            margin-bottom: 34px;
          /*  overflow: hidden;      
            text-overflow: ellipsis;      
            display: -webkit-box;      
            -webkit-line-clamp: 4;      
            -webkit-box-orient: vertical; */
          }
          .date{
            span{            
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #900211;
              line-height: 20px;
              margin-right: 10px;
              cursor: pointer;
            };
          }
        }
      }
    }
    .pagination{
      text-align: center;
      margin-top: 55px;
      margin-bottom: 100px;
      /deep/ .el-pager li.active{
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #900211;
      }
      /deep/ .el-pager li{
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #9A9A9A;
      }
      /deep/ .btn-next{
        color:#900211 !important;
      }
      /deep/ .btn-next:hover{
        color:#900211;
      }
    }
  }
}
</style>
